// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   FiPlus, FiMinus, FiShoppingBag, FiArrowLeft, FiTruck, FiShield, FiCreditCard
// } from "react-icons/fi";
// import { IoClose } from "react-icons/io5";

// export default function Cart({ cart = [], removeFromCart, updateQty, clearCart, addToCart }) {
//   const navigate = useNavigate();
//   const [showClearConfirm, setShowClearConfirm] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState("ONLINE");

//   const subtotal = cart.reduce((sum, item) => sum + (item.price || 0) * (item.qty || 1), 0);
//   const deliveryFee = paymentMethod === "COD" ? 30 : 0;
//   const platformFee = 0;
//   // const gst = subtotal * 0.05;
//   const total = subtotal + deliveryFee + platformFee;

//   const handleCheckout = () => {
//     if (cart.length === 0) {
//       window.dispatchEvent(new CustomEvent("showNotification", { detail: { message: "Your cart is empty!", type: "warning" } }));
//       return;
//     }
//     navigate("/checkout", { state: { paymentMethod } });
//   };

//   const handleClearCart = () => {
//     clearCart();
//     setShowClearConfirm(false);
//     window.dispatchEvent(new CustomEvent("showNotification", { detail: { message: "Cart cleared!", type: "info" } }));
//   };

//   const handleIncrease = (item) => {
//     updateQty(item._id, (item.qty || 1) + 1);
//   };

//   const handleDecrease = (item) => {
//     if ((item.qty || 1) <= 1) {
//       removeFromCart(item._id);
//       window.dispatchEvent(new CustomEvent("showNotification", { detail: { message: `${item.name} removed`, type: "info" } }));
//     } else {
//       updateQty(item._id, (item.qty || 1) - 1);
//     }
//   };

//   /* ══════════════════════════════════════════════════════════
//      NOTE FOR DEVELOPERS
//      ══════════════════════════════════════════════════════════
//      When calling addToCart() from any product page, ALWAYS
//      include vendorId in the item object:

//      addToCart({
//        _id: product._id,
//        name: product.name,
//        price: product.price,
//        image: product.images?.[0] || product.image,
//        category: product.category,
//        vendorId: product.vendor?._id || product.vendorId,  ← THIS IS REQUIRED
//      });

//      Without vendorId, ParcelX order creation will fail.
//   ══════════════════════════════════════════════════════════ */

//   if (cart.length === 0) {
//     return (
//       <div className="min-h-screen bg-gray-50 sm:pt-20">
//         <div className="container mx-auto px-4 py-12">
//           <div className="max-w-md mx-auto text-center">
//             <motion.div
//               initial={{ scale: 0 }}
//               animate={{ scale: 1 }}
//               transition={{ type: "spring", stiffness: 200 }}
//               className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6"
//             >
//               <FiShoppingBag className="text-red-600 text-3xl" />
//             </motion.div>
//             <h1 className="text-2xl font-bold text-gray-900 mb-4">Your Cart is Empty</h1>
//             <p className="text-gray-600 mb-8">Add some amazing wellness products to get started!</p>
//             <button
//               onClick={() => navigate("/products")}
//               className="px-6 py-3 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 transition-colors shadow-md"
//             >
//               Start Shopping
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">

//       {/* ── Header ── */}
//       <div className="bg-white sticky top-0 z-30 border-b">
//         <div className="container mx-auto px-4 py-4">
//           <div className="flex items-center justify-between">
//             <button onClick={() => navigate("/")} className="flex items-center gap-2 text-gray-700 hover:text-red-600">
//               <FiArrowLeft />
//               <span className="hidden sm:inline">Continue Shopping</span>
//               <span className="sm:hidden">Back</span>
//             </button>
//             <h1 className="text-xl font-bold text-gray-900">Shopping Cart ({cart.length})</h1>
//             <button
//               onClick={() => setShowClearConfirm(true)}
//               className="text-red-600 text-sm font-medium hover:text-red-700"
//             >
//               Clear All
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="container mx-auto px-4 py-6">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

//           {/* ── Cart Items ── */}
//           <div className="lg:col-span-2">

//             {/* Combo Banner */}
//             {cart.length >= 2 && (
//               <div className="bg-gradient-to-r from-red-500 to-red-600 text-white rounded-xl p-4 mb-4 shadow-md">
//                 <div className="flex items-center justify-between">
//                   <div className="flex items-center gap-3">
//                     <FiShield className="text-white" size={20} />
//                     <div>
//                       <h3 className="font-bold text-lg">Combo Savings!</h3>
//                       <p className="text-sm opacity-90">You saved Rs.{(subtotal * 0.1).toFixed(2)} by buying together</p>
//                     </div>
//                   </div>
//                   <span className="bg-white text-xs text-red-600 px-3 py-1 rounded-full font-bold">Save 10%</span>
//                 </div>
//               </div>
//             )}

//             <AnimatePresence>
//               {cart.map((item) => (
//                 <motion.div
//                   key={`${item._id}-${item.qty}`}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   exit={{ opacity: 0, scale: 0.9 }}
//                   transition={{ duration: 0.2 }}
//                   className="bg-white rounded-2xl shadow-sm border border-gray-100 mb-4 overflow-hidden"
//                 >
//                   <div className="p-4">
//                     <div className="flex gap-4">
//                       {/* Product Image */}
//                       <div className="flex-shrink-0">
//                         <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-xl overflow-hidden bg-gray-100">
//                           <img
//                             src={item.image || item.images?.[0] || "/placeholder.png"}
//                             alt={item.name}
//                             className="w-full h-full object-cover"
//                             onError={(e) => { e.target.src = "/placeholder.png"; }}
//                           />
//                         </div>
//                       </div>

//                       {/* Product Details */}
//                       <div className="flex-1 min-w-0">
//                         <div className="flex justify-between">
//                           <div className="min-w-0">
//                             <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-1 truncate">{item.name}</h3>
//                             {(item.vendorId || item.vendor) && (
//                               <span className="inline-block text-[10px] bg-green-100 text-green-700 px-2 py-0.5 rounded">
//                                 Vendor verified
//                               </span>
//                             )}
//                           </div>
//                           <button
//                             onClick={() => {
//                               removeFromCart(item._id);
//                               window.dispatchEvent(new CustomEvent("showNotification", {
//                                 detail: { message: `${item.name} removed`, type: "info" }
//                               }));
//                             }}
//                             className="text-gray-400 hover:text-red-500 h-fit flex-shrink-0 ml-2"
//                           >
//                             <IoClose size={20} />
//                           </button>
//                         </div>

//                         {/* Price + Qty */}
//                         <div className="mt-3 flex items-center justify-between">
//                           <div>
//                             <div className="flex items-baseline gap-2">
//                               <p className="text-lg sm:text-xl font-bold text-gray-900">
//                                 Rs.{(item.price || 0).toLocaleString()}
//                               </p>
//                               {item.originalPrice && item.originalPrice > item.price && (
//                                 <>
//                                   <p className="text-xs sm:text-sm text-gray-400 line-through">
//                                     Rs.{item.originalPrice.toLocaleString()}
//                                   </p>
//                                   <span className="text-xs bg-red-100 text-red-600 px-1.5 py-0.5 rounded">
//                                     Save Rs.{item.originalPrice - item.price}
//                                   </span>
//                                 </>
//                               )}
//                             </div>
//                           </div>

//                           <div className="flex items-center gap-3 sm:gap-4">
//                             {/* Qty Controls */}
//                             <div className="flex items-center border border-red-200 bg-red-50 rounded-full">
//                               <button
//                                 onClick={() => handleDecrease(item)}
//                                 className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-red-600 hover:bg-red-100 rounded-l-full"
//                               >
//                                 <FiMinus size={16} />
//                               </button>
//                               <span className="w-8 sm:w-12 text-center font-medium text-sm sm:text-base text-red-700">
//                                 {item.qty || 1}
//                               </span>
//                               <button
//                                 onClick={() => handleIncrease(item)}
//                                 className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-red-600 hover:bg-red-100 rounded-r-full"
//                               >
//                                 <FiPlus size={16} />
//                               </button>
//                             </div>

//                             {/* Item Total (desktop) */}
//                             <div className="text-right hidden sm:block">
//                               <p className="text-xs text-gray-400">Total</p>
//                               <p className="text-lg font-bold text-red-600">
//                                 Rs.{((item.price || 0) * (item.qty || 1)).toLocaleString()}
//                               </p>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Item Total (mobile) */}
//                         <div className="mt-3 sm:hidden border-t pt-3 flex justify-between items-center">
//                           <span className="text-sm text-gray-500">Item Total</span>
//                           <p className="text-lg font-bold text-red-600">
//                             Rs.{((item.price || 0) * (item.qty || 1)).toLocaleString()}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </AnimatePresence>
//           </div>

//           {/* ── Order Summary ── */}
//           {/* <div className="lg:col-span-1"> */}
//           <div className="lg:col-span-1 hidden">
//             <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-5 lg:sticky lg:top-28">
//               <h2 className="text-lg font-bold text-gray-900 mb-4">Order Summary</h2>

//               {/* Payment Method Selector */}
//               <div className="mb-5">
//                 <p className="text-sm font-semibold text-gray-700 mb-2">Payment Method</p>
//                 <div className="flex gap-2">
//                   {["ONLINE", "COD"].map((method) => (
//                     <button
//                       key={method}
//                       onClick={() => setPaymentMethod(method)}
//                       className={`flex-1 py-2.5 rounded-xl text-sm font-medium border transition-all duration-200 ${
//                         paymentMethod === method
//                           ? "bg-red-600 text-white border-red-600 shadow-md"
//                           : "bg-white text-gray-600 border-gray-300 hover:border-red-400"
//                       }`}
//                     >
//                       {method === "COD" ? "Cash on Delivery" : "Online Payment"}
//                     </button>
//                   ))}
//                 </div>
//                 {paymentMethod === "COD" && (
//                   <p className="text-xs text-orange-600 mt-2 flex items-center gap-1">
//                     ⚠️ COD pe Rs.30 delivery charge lagega
//                   </p>
//                 )}
//                 {paymentMethod === "ONLINE" && (
//                   <p className="text-xs text-green-600 mt-2 flex items-center gap-1">
//                     ✅ Online payment pe FREE delivery!
//                   </p>
//                 )}
//               </div>

//               {/* Price Breakdown */}
//               <div className="space-y-3 mb-5">
//                 <div className="flex justify-between items-center">
//                   <span className="text-gray-600">Subtotal</span>
//                   <span className="font-medium">Rs.{subtotal.toFixed(2)}</span>
//                 </div>

//                 {cart.length >= 2 && (
//                   <div className="flex justify-between items-center">
//                     <span className="text-gray-600">Combo Discount</span>
//                     <span className="font-medium text-red-600">-Rs.{(subtotal * 0.1).toFixed(2)}</span>
//                   </div>
//                 )}

//                 <div className="flex justify-between items-center">
//                   <span className="text-gray-600">Delivery</span>
//                   <span className={`font-medium ${deliveryFee === 0 ? "text-green-600 font-bold" : "text-orange-600"}`}>
//                     {deliveryFee === 0 ? "FREE" : `Rs.${deliveryFee}`}
//                   </span>
//                 </div>

//                 {/* <div className="flex justify-between items-center">
//                   <span className="text-gray-600">Platform Fee</span>
//                   <span className="font-medium">Rs.{platformFee}</span>
//                 </div>

//                 <div className="flex justify-between items-center">
//                   <span className="text-gray-600">GST (5%)</span>
//                   <span className="font-medium">Rs.{gst.toFixed(2)}</span>
//                 </div> */}

//                 <div className="border-t border-gray-200 pt-3 mt-3">
//                   <div className="flex justify-between items-center">
//                     <span className="text-lg font-bold text-gray-900">Total</span>
//                     <span className="text-xl sm:text-2xl font-bold text-red-600">Rs.{total.toFixed(2)}</span>
//                   </div>
//                 </div>
//               </div>

//               Checkout Button (desktop)
//               <button
//                 onClick={handleCheckout}
//                 className="hidden lg:flex w-full py-3.5 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 transition-colors shadow-lg items-center justify-center gap-3 mb-4"
//               >
//                 <FiCreditCard /> Proceed to Checkout
//               </button>
              

//                  {/* Trust Badges */}
//               <div className="space-y-2.5">
//                 <div className="flex items-center gap-2 text-sm text-gray-600">
//                   <FiTruck className="flex-shrink-0" />
//                   <span>
//                     {paymentMethod === "COD"
//                       ? "COD available • Rs.30 delivery charge"
//                       : "Free delivery on online payment"}
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-2 text-sm text-gray-600">
//                   <FiShield className="flex-shrink-0" />
//                   <span>Secure payment - 100% Safe</span>
//                 </div>
//               </div>

//               {/* Accepted Payments */}
//               <div className="mt-5 pt-4 border-t border-gray-100">
//                 <p className="text-xs sm:text-sm text-gray-600 mb-3">We accept</p>
//                 <div className="flex flex-wrap gap-2">
//                   {["VISA", "MasterCard", "UPI", "Net Banking", "COD"].map((m) => (
//                     <div
//                       key={m}
//                       className={`px-2 py-1 sm:px-3 sm:py-1.5 rounded-lg text-xs font-medium transition-colors ${
//                         (paymentMethod === "COD" && m === "COD") ||
//                         (paymentMethod === "ONLINE" && m !== "COD")
//                           ? "bg-red-100 text-red-700"
//                           : "bg-gray-100 text-gray-700"
//                       }`}
//                     >
//                       {m}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── Mobile Checkout Bar ── */}
//       <div className="fixed bottom-20 left-0 right-0 bg-white border-t border-gray-200 lg:hidden shadow-lg z-40">
//         <div className="flex items-center justify-between px-4 py-3">
//           <div>
//             <p className="text-xs text-gray-500">
//               Total • {paymentMethod === "COD" ? "COD" : "Online"}
//             </p>
//             <p className="text-base font-bold text-red-600">Rs.{total.toFixed(2)}</p>
//           </div>
//           <button
//             onClick={handleCheckout}
//             className="px-6 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors text-sm shadow-md"
//           >
//             Checkout
//           </button>
//         </div>
//       </div>

//       <div className="pb-24 lg:pb-0" />

//       {/* ── Clear Cart Modal ── */}
//       <AnimatePresence>
//         {showClearConfirm && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
//             onClick={() => setShowClearConfirm(false)}
//           >
//             <motion.div
//               initial={{ scale: 0.9 }}
//               animate={{ scale: 1 }}
//               exit={{ scale: 0.9 }}
//               className="bg-white rounded-2xl p-6 max-w-sm w-full"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <h3 className="text-lg font-bold text-gray-900 mb-2">Clear Cart?</h3>
//               <p className="text-gray-600 mb-6">Remove all {cart.length} items from your cart?</p>
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => setShowClearConfirm(false)}
//                   className="flex-1 py-3 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleClearCart}
//                   className="flex-1 py-3 bg-red-600 text-white font-medium rounded-xl hover:bg-red-700"
//                 >
//                   Clear All
//                 </button>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }









import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiPlus, FiMinus, FiShoppingBag, FiArrowLeft, FiTruck, FiShield, FiCreditCard
} from "react-icons/fi";
import { IoClose } from "react-icons/io5";

export default function Cart({ cart = [], removeFromCart, updateQty, clearCart, addToCart }) {
  const navigate = useNavigate();
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("ONLINE");

  const subtotal = cart.reduce((sum, item) => sum + (item.price || 0) * (item.qty || 1), 0);
  const deliveryFee = paymentMethod === "COD" ? 30 : 0;
  const total = subtotal + deliveryFee;

  const handleCheckout = () => {
    if (cart.length === 0) {
      window.dispatchEvent(new CustomEvent("showNotification", { detail: { message: "Your cart is empty!", type: "warning" } }));
      return;
    }
    navigate("/checkout", { state: { paymentMethod } });
  };

  const handleClearCart = () => {
    clearCart();
    setShowClearConfirm(false);
    window.dispatchEvent(new CustomEvent("showNotification", { detail: { message: "Cart cleared!", type: "info" } }));
  };

  const handleIncrease = (item) => {
    updateQty(item._id, (item.qty || 1) + 1);
  };

  const handleDecrease = (item) => {
    if ((item.qty || 1) <= 1) {
      removeFromCart(item._id);
      window.dispatchEvent(new CustomEvent("showNotification", { detail: { message: `${item.name} removed`, type: "info" } }));
    } else {
      updateQty(item._id, (item.qty || 1) - 1);
    }
  };



  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 sm:pt-20">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-md mx-auto text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="w-24 h-24 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6"
            >
              <FiShoppingBag className="text-red-600 text-3xl" />
            </motion.div>
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Your Cart is Empty</h1>
            <p className="text-gray-600 mb-8">Add some amazing wellness products to get started!</p>
            <button
              onClick={() => navigate("/products")}
              className="px-6 py-3 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 transition-colors shadow-md"
            >
              Start Shopping
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">

      {/* ── Header ── */}
      <div className="bg-white sticky top-0 z-30 border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <button onClick={() => navigate("/")} className="flex items-center gap-2 text-gray-700 hover:text-red-600">
              <FiArrowLeft />
              <span className="hidden sm:inline">Continue Shopping</span>
              <span className="sm:hidden">Back</span>
            </button>
            <h1 className="text-xl font-bold text-gray-900">Shopping Cart ({cart.length})</h1>
            <button
              onClick={() => setShowClearConfirm(true)}
              className="text-red-600 text-sm font-medium hover:text-red-700"
            >
              Clear All
            </button>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-6">
        <div className="max-w-3xl mx-auto">

          {/* ── Cart Items ── */}
          <AnimatePresence>
            {cart.map((item) => (
              <motion.div
                key={`${item._id}-${item.qty}`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.2 }}
                className="bg-white rounded-2xl shadow-sm border border-gray-100 mb-4 overflow-hidden"
              >
                <div className="p-4">
                  <div className="flex gap-4">
                    {/* Product Image */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-xl overflow-hidden bg-gray-100">
                        <img
                          src={item.image || item.images?.[0] || "/placeholder.png"}
                          alt={item.name}
                          className="w-full h-full object-cover"
                          onError={(e) => { e.target.src = "/placeholder.png"; }}
                        />
                      </div>
                    </div>

                    {/* Product Details */}
                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between">
                        <div className="min-w-0">
                          <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-1 truncate">{item.name}</h3>
                          {(item.vendorId || item.vendor) && (
                            <span className="inline-block text-[10px] bg-green-100 text-green-700 px-2 py-0.5 rounded">
                              Vendor verified
                            </span>
                          )}
                        </div>
                        <button
                          onClick={() => {
                            removeFromCart(item._id);
                            window.dispatchEvent(new CustomEvent("showNotification", {
                              detail: { message: `${item.name} removed`, type: "info" }
                            }));
                          }}
                          className="text-gray-400 hover:text-red-500 h-fit flex-shrink-0 ml-2"
                        >
                          <IoClose size={20} />
                        </button>
                      </div>

                      {/* Price + Qty */}
                      <div className="mt-3 flex items-center justify-between">
                        <div>
                          <div className="flex items-baseline gap-2">
                            <p className="text-lg sm:text-xl font-bold text-gray-900">
                              Rs.{(item.price || 0).toLocaleString()}
                            </p>
                            {item.originalPrice && item.originalPrice > item.price && (
                              <>
                                <p className="text-xs sm:text-sm text-gray-400 line-through">
                                  Rs.{item.originalPrice.toLocaleString()}
                                </p>
                                <span className="text-xs bg-red-100 text-red-600 px-1.5 py-0.5 rounded">
                                  Save Rs.{item.originalPrice - item.price}
                                </span>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="flex items-center gap-3 sm:gap-4">
                          {/* Qty Controls */}
                          <div className="flex items-center border border-red-200 bg-red-50 rounded-full">
                            <button
                              onClick={() => handleDecrease(item)}
                              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-red-600 hover:bg-red-100 rounded-l-full"
                            >
                              <FiMinus size={16} />
                            </button>
                            <span className="w-8 sm:w-12 text-center font-medium text-sm sm:text-base text-red-700">
                              {item.qty || 1}
                            </span>
                            <button
                              onClick={() => handleIncrease(item)}
                              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-red-600 hover:bg-red-100 rounded-r-full"
                            >
                              <FiPlus size={16} />
                            </button>
                          </div>

                          {/* Item Total (desktop) */}
                          {/* <div className="text-right hidden sm:block">
                            <p className="text-xs text-gray-400">Total</p>
                            <p className="text-lg font-bold text-red-600">
                              Rs.{((item.price || 0) * (item.qty || 1)).toLocaleString()}
                            </p>
                          </div> */}
                        </div>
                      </div>

                      {/* Item Total (mobile) */}
                      {/* <div className="mt-3 sm:hidden border-t pt-3 flex justify-between items-center">
                        <span className="text-sm text-gray-500">Item Total</span>
                        <p className="text-lg font-bold text-red-600">
                          Rs.{((item.price || 0) * (item.qty || 1)).toLocaleString()}
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>

          {/* ── Bill Details ── */}
          <section className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mt-5">
            <div className="px-4 sm:px-5 py-4 border-b border-gray-100">
              <h2 className="text-base font-bold text-gray-900">Bill details</h2>
              <p className="text-xs text-gray-500 mt-1">Transparent pricing, no surprises</p>
            </div>

            <div className="px-4 sm:px-5 py-4 space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600">Items total <span className="text-xs text-gray-400">({cart.length} item{cart.length === 1 ? "" : "s"})</span></span>
                <span className="font-medium text-gray-900">Rs.{subtotal.toFixed(2)}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600 flex items-center gap-1.5">
                  Delivery charge
                  <span className="text-[10px] text-gray-400 border border-gray-300 rounded-full w-3.5 h-3.5 inline-flex items-center justify-center">i</span>
                </span>
                <span className={`font-medium ${deliveryFee === 0 ? "text-green-600" : "text-gray-900"}`}>
                  {deliveryFee === 0 ? "FREE" : `Rs.${deliveryFee}`}
                </span>
              </div>
              <div className="border-t border-dashed border-gray-200 pt-3 mt-1 flex items-center justify-between">
                <span className="font-bold text-gray-900">Grand total</span>
                <span className="text-lg font-extrabold text-gray-900">Rs.{total.toFixed(2)}</span>
              </div>

            </div>
          </section>

          {/* ── Desktop Checkout Bar (hidden on mobile) ── */}
          <div className="hidden lg:flex items-center justify-between bg-white rounded-2xl shadow-sm border border-gray-100 px-6 py-4 mt-2">
            <div className="flex items-center gap-6">
              <div>
                <p className="text-sm text-gray-500">Total Amount</p>
                <p className="text-2xl font-bold text-red-600">Rs.{total.toFixed(2)}</p>
              </div>
              {/* <div className="flex items-center gap-2 text-sm text-gray-500">
                <FiTruck size={15} />
                <span>{paymentMethod === "COD" ? "COD • Rs.30 delivery" : "FREE delivery"}</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <FiShield size={15} />
                <span>100% Secure</span>
              </div> */}
            </div>

            <div className="flex items-center gap-3">
              {/* Payment Method Toggle */}
              {/* <div className="flex gap-2">
                {["ONLINE", "COD"].map((method) => (
                  <button
                    key={method}
                    onClick={() => setPaymentMethod(method)}
                    className={`px-4 py-2 rounded-xl text-sm font-medium border transition-all duration-200 ${
                      paymentMethod === method
                        ? "bg-red-600 text-white border-red-600 shadow-md"
                        : "bg-white text-gray-600 border-gray-300 hover:border-red-400"
                    }`}
                  >
                    {method === "COD" ? "Cash on Delivery" : "Online Payment"}
                  </button>
                ))}
              </div> */}

              {/* Proceed to Checkout Button */}
              <button
                onClick={handleCheckout}
                className="flex items-center gap-2 px-8 py-3 bg-red-600 text-white font-bold rounded-xl hover:bg-red-700 transition-colors shadow-lg whitespace-nowrap"
              >
                <FiCreditCard size={18} />
                Proceed to Checkout
              </button>
            </div>
          </div>

        </div>
      </div>

      {/* ── Mobile Checkout Bar (hidden on desktop) ── */}
      <div className="fixed bottom-20 left-0 right-0 bg-white border-t border-gray-200 lg:hidden shadow-lg z-40">
        <div className="flex items-center justify-between px-4 py-3">
          <div>
            <p className="text-xs text-gray-500">
              Total • {paymentMethod === "COD" ? "COD" : "Online"}
            </p>
            <p className="text-base font-bold text-red-600">Rs.{total.toFixed(2)}</p>
          </div>
          <div className="flex items-center gap-2">
            {/* Payment Toggle (mobile) */}
            {/* <div className="flex gap-1">
              {["ONLINE", "COD"].map((method) => (
                <button
                  key={method}
                  onClick={() => setPaymentMethod(method)}
                  className={`px-2.5 py-1.5 rounded-lg text-xs font-medium border transition-all ${
                    paymentMethod === method
                      ? "bg-red-600 text-white border-red-600"
                      : "bg-white text-gray-600 border-gray-300"
                  }`}
                >
                  {method === "COD" ? "COD" : "Online"}
                </button>
              ))}
            </div> */}
            <button
              onClick={handleCheckout}
              className="px-5 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors text-sm shadow-md"
            >
              Checkout
            </button>
          </div>
        </div>
      </div>

      <div className="pb-24 lg:pb-0" />

      {/* ── Clear Cart Modal ── */}
      <AnimatePresence>
        {showClearConfirm && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
            onClick={() => setShowClearConfirm(false)}
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              className="bg-white rounded-2xl p-6 max-w-sm w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-lg font-bold text-gray-900 mb-2">Clear Cart?</h3>
              <p className="text-gray-600 mb-6">Remove all {cart.length} items from your cart?</p>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowClearConfirm(false)}
                  className="flex-1 py-3 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleClearCart}
                  className="flex-1 py-3 bg-red-600 text-white font-medium rounded-xl hover:bg-red-700"
                >
                  Clear All
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}